import { render, staticRenderFns } from "./waste_popup.vue?vue&type=template&id=10f62844&"
import script from "./waste_popup.vue?vue&type=script&lang=js&"
export * from "./waste_popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports